import { customFieldsService } from "../../../services/customFields";
import { useWSMutation } from "../../helpers";
import { QUERY_CUSTOM_FIELDS_ALL } from "../keys";

export const useMutationDeleteCustomField = () =>
  useWSMutation((id: string) => customFieldsService.customField.delete(id), {
    dependencies: [QUERY_CUSTOM_FIELDS_ALL]
  });
